"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchPreviewProductSkeletonContainer = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _components = require("../../components");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file @preserve --container */

const SearchPreviewProductSkeletonContainer = ({
  responsive,
  ...props
}) => {
  const theme = (0, _react.useMemo)(() => (0, _mui.createTheme)({
    responsiveLayout: responsive
  }), [responsive]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SearchPreviewProductSkeleton, {
      ...props
    })
  });
};
exports.SearchPreviewProductSkeletonContainer = SearchPreviewProductSkeletonContainer;
//# sourceMappingURL=SearchPreviewProductSkeletonContainer.js.map